<link rel="stylesheet" href="https://sandbox.optomiser.com/StyleBundle/FontAwesome"   crossorigin="anonymous" />

<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="currentItem==null">
    <div class="float-end">
      <a class="btn btn-secondary" [routerLink]="['/navigation/categories']">View categories</a>
    </div>
    <h1 class="content-heading-font">Navigation Links</h1>


    <div class="row">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [totalRecords]="list?.FilteredRecords"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
                 sortMode="multiple">


          <ng-template pTemplate="header">
            <tr>
              <th class="text-end" style="width:120px;"></th>
              <th pSortableColumn="ID" class="text-end d-none d-md-table-cell">
                #
                <p-sortIcon field="ID"></p-sortIcon>
                <p-columnFilter type="numeric" field="ID" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="LinkName" class="text-start">
                Name
                <p-sortIcon field="LinkName"></p-sortIcon>
                <p-columnFilter type="text" field="LinkName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th class="text-start d-none d-xl-table-cell">
                Categories
              </th>
              <th pSortableColumn="URL" class="text-center  d-none d-lg-table-cell">
                URL <p-sortIcon field="URL"></p-sortIcon>
                <p-columnFilter type="text" field="URL" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Icon" class="text-center  d-none d-xxl-table-cell">
                Icon <p-sortIcon field="Icon"></p-sortIcon>
                <p-columnFilter type="text" field="Icon" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="ImageLocation" class="text-start  d-none d-xxl-table-cell">
                Image <p-sortIcon field="ImageLocation"></p-sortIcon>
                <p-columnFilter type="text" field="ImageLocation" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Inactive" class="text-start d-none d-xxl-table-cell">
                Status <p-sortIcon field="Inactive"></p-sortIcon>
                <p-columnFilter type="boolean" field="Inactive" matchMode="contains" display="menu" [showMatchModes]="false" [showOperator]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown [options]="[{ name: 'Any', value: '' },{ name: 'Active', value: 'false' },{ name: 'Inactive', value: 'true' }]" [ngModel]="value" placeholder="Any" (onChange)="filter($event.value)" optionLabel="name" optionValue="value">
                    </p-dropdown>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th pSortableColumn="Permissions" class="text-end d-none d-xxl-table-cell">
                Permissions <p-sortIcon field="Permissions"></p-sortIcon>
                <p-columnFilter type="numeric" field="Permissions" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <th class="text-end">
                <div class="gap-2 d-block ">
                  <a class="btn btn-sm btn-primary me-1 " (click)="onRowEditInit(item)" title="Edit">
                    <i class="pi pi-pen-to-square"></i>
                  </a>
                  <a class="btn btn-sm btn-warning  " (click)="onRowDeleteInit(item)" title="Delete">
                    <i class="pi pi-trash"></i>
                  </a>
                </div>
              </th>
              <th class="text-end d-none d-md-table-cell">{{ item.ID }}</th>
              <td>
                <img [src]="getItemImage(item)" class="smallBussinesLogo d-inline-block d-xxl-none" *ngIf="getItemImage(item)" />
                <i class="{{ item.Icon }} d-inline-block d-xxl-none" *ngIf="item.Icon!=null"></i>
                {{ item.LinkName }}
              </td>
              <td class=" d-none d-xl-table-cell  text-truncate">{{ item.Categories }}</td>
              <th class="text-start d-none d-lg-table-cell text-truncate">{{ item.URL }}</th>
              <td class=" d-none d-xxl-table-cell text-center">
                <i class="{{ item.Icon }}" *ngIf="item.Icon!=null"></i>
              </td>
              <td class=" d-none d-xxl-table-cell text-center">
                <img [src]="getItemImage(item)" class="smallBussinesLogo" *ngIf="item.ImageLocation" />                
              </td>
              <td class=" d-none d-xxl-table-cell ">
                <div [ngClass]="{'text-danger': item.Inactive, 'text-success': !item.Inactive}">
                  {{ item.Inactive?'Inactive':'Active' }}
                </div>
              </td>
              <td class="text-end d-none d-xxl-table-cell">
                <a href="#" [routerLink]="['/permissions']" [queryParams]="{navigationLinkID: item.ID}">
                  {{ item.Permissions |  number  }}
                </a>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft">
            <button class="btn btn-primary " (click)="addItem(dt1)" title="Add item">
              <i class="pi pi-plus"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="loadTable(null)" title="Refress">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">No items found.</td>
            </tr>
          </ng-template>
        </p-table>



      </div>
    </div>

  </div>

  <div class="main-page-content-block" *ngIf="currentItem!=null">
    <div class="float-end">
      <a class="btn btn-secondary" (click)="cancel()">View list</a>
    </div>

    <h1 class="content-heading-font">

      <span *ngIf="currentItem && currentItem.ID">
        Navigation Link #{{currentItem.ID }} - {{currentItem.LinkName }}
      </span>
      <span *ngIf="!(currentItem && currentItem.ID)">
        New Navigation Link
      </span>
    </h1>


    <form #itemForm="ngForm" [formGroup]="itemFormGroup">
      <div class="row">
        <div class="col mb-3">
          <label for="LinkName">Name</label>
          <input class="form-control" name="LinkName" formControlName="LinkName" autocomplete="off" placeholder="Name" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="URL">URL</label>
          <input class="form-control" name="URL" formControlName="URL" autocomplete="off" placeholder="URL" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Parameter">Parameter</label>
          <input class="form-control" name="Parameter" formControlName="Parameter" autocomplete="off" placeholder="Parameter" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Icon">Icon <a href="https://fontawesome.com/v6/icons" target="icons"><i class="ms-2 pi pi-info-circle" style="font-size: 0.7rem"></i></a></label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <div style=" height: 24px; width: 20px;">
                  <i class="fa-fw {{ IconValue }}" *ngIf="IconValue"></i>
                </div>
              </div>
            </div>
            <input class="form-control" name="Icon" formControlName="Icon" autocomplete="off" placeholder="Icon" />
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="ImageLocation">Image</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <div style=" height: 24px; width: 20px;">
                  <img [src]="ImageLocationValue" class="fa-fw " *ngIf="ImageLocationValue" />
                </div>
              </div>
            </div>
            <input class="form-control" name="ImageLocation" formControlName="ImageLocation" autocomplete="off" placeholder="Image URL" />
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Inactive">Status</label>
          <select class="form-control" name="Inactive" formControlName="Inactive">
            <option value="false">Active</option>
            <option value="true">Inactive</option>
          </select>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col mb-3">
          <div for="Categories" class="mb-1 align-items-baseline">
            Categories: <button class="ms-2 btn btn-outline-primary   " (click)="addCategory()" title="Add item" type="button"><i class="pi pi-plus"></i></button>
          </div>
          <ng-container formArrayName="Categories">
            <ng-container *ngFor="let categoriesForm of Categories.controls; let i = index">
              <table class="w-100 mb-1" [formGroupName]="i">
                <tr>
                  <td>
                    <div class="row g-0 ">
                      <div class="col-6">
                        <label for="NavCategoryID">Category:</label>
                        <select name="NavCategoryID" formControlName="NavCategoryID" autocomplete="off" [class.div-loading]="loadingNavigationCategories" class="form-control">
                          <option *ngFor="let category of navigationCategories" [ngValue]="category.ID">
                            {{category.CategoryName}}
                            {{category.IsPatientNav?'[Patient]':''}}
                          </option>
                        </select>


                      </div>
                      <div class="col-6 ps-2">
                        <label for="OrderNumber">Order Number:</label>
                        <input class=" form-control" type="number" min="0" name="OrderNumber" formControlName="OrderNumber" autocomplete="off" />
                      </div>
                    </div>
                  </td>
                  <td style="width: 50px;vertical-align:bottom; text-align:right">
                    <button class="btn  btn-outline-danger" (click)="deleteCategory(i)" title="Remove item" type="button"><i class="pi pi-trash"></i></button>
                  </td>
                </tr>
              </table>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col mb-3">
          <div for="PermissionItems" class="mb-1 align-items-baseline" >
            Permissions:  <button class="ms-2 btn btn-outline-primary   " (click)="addPermission()" title="Add item" type="button" *ngIf="permissions"><i class="pi pi-plus"></i></button>
          </div>
          <div class="div-loading" *ngIf="loadingPermissions">
            &nbsp;
          </div>
          <ng-container formArrayName="PermissionItems">
            <ng-container *ngFor="let permissionForm of PermissionItems.controls; let i = index">
              <table class="w-100 mb-1" [formGroupName]="i">
                <tr>
                  <td>
                    <div class="row g-0">
                      <div class="col-12" >
                        <p-autoComplete class="form-control" name="PermissionItem" formControlName="PermissionItem"
                                        [dropdown]="true"
                                        dropdownMode="current"
                                        [forceSelection]="true"
                                        [suggestions]="filteredPermissions"
                                        (completeMethod)="filterPermission($event)"
                                        [optionLabel]="labelPermission"
                                        autocomplete="off"
                                        minLength="0">
                         
                        </p-autoComplete>
                      </div>

                    </div>
                  </td>
                  <td style="width: 50px;vertical-align:bottom; text-align:right">
                    <button class="btn  btn-outline-danger" (click)="deletePermission(i)" title="Remove item" type="button"><i class="pi pi-trash"></i></button>
                  </td>
                </tr>
              </table>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="btn btn-lg btn-primary" type="submit" id="btnSave" [class.button-loading]="loading" (click)="save()">Save</button>
        </div>
      </div>
    </form>
  </div>
</div>

